import { SeuOperatingConditionCategory } from '@seu-types';
import { neverError } from './never.helper';

export function getOperatingConditionCategoryLabel(
  key: SeuOperatingConditionCategory
): string {
  switch (key) {
    case 'WARRANTY':
      return 'operating-condition.types.warranty';
    case 'PART_LOAD':
      return 'operating-condition.types.part';
    case 'MAXIMUM_LOAD':
      return 'operating-condition.types.full';
    case 'NOMINAL':
      return 'operating-condition.types.nominal';
    case 'OTHER':
      return 'operating-condition.types.other';
    default:
      throw neverError(key);
  }
}
